import Asset from '~/cms/components/Asset'
import {WYSIWYGSingleLineStructuredText} from '~/cms/components/WYSIWYG/_components/WYSIWYGSingleLineStructuredText'
import {type HgMediaAssetProps} from '~/design-system/hg/components/HgWYSIWYG/Article/_components/HgMediaAsset'
import {themeToClassName, type Theme} from '~/design-system/hg/tokens/colors'
import {type MediaAssetFragment} from './_generated/fragment.graphql'

export function getMediaAssetProps(data: MediaAssetFragment) {
  const controlsTheme = (
    data.controlsTheme && data.controlsTheme.name in themeToClassName
      ? data.controlsTheme.name
      : 'neutral'
  ) as Theme
  const aspectRatio = data.aspectRatio as HgMediaAssetProps['aspectRatio']

  return {
    assetId: data.id,
    asset: (
      <Asset
        data={data.asset}
        aspectRatio={aspectRatio}
        datoAnimationProps={{controlsTheme}}
      />
    ),
    caption: data.caption ? (
      <WYSIWYGSingleLineStructuredText data={data.caption} />
    ) : undefined,
    credit: data.credit ? (
      <WYSIWYGSingleLineStructuredText data={data.credit} />
    ) : undefined,
    controlsTheme,
    aspectRatio,
  }
}
